import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../Components/FilterTable/filterTableUtils";
import texts from "./texts";
import { type TableNotification } from "./types";

const itemsDescriptions: FilterTableItemDescriptor<TableNotification>[] = [
  {
    headerText: texts.table.headers.type,
    value: "providerType",
  },
  {
    headerText: texts.table.headers.selectedNotifications,
    value: "selectedNotificationsKeys",
  },
  {
    value: "@",
    headerText: "",
  },
];

export const { headerColumns, filters } = generateHeadersAndFilters(itemsDescriptions);
